<template>
  <div class="main-media">
    <figure class="single-image" v-if="media.type === 'image'">
      <vue-picture :imgset="media.image" :sizes="sizes" aspect="wide2_41"/>
    </figure>
    <vue-slideshow
      v-if="media.type === 'gallery'"
      :images="media.items"
      :sizes="sizes"
      :speed="speed"
      :showNav="full"
      aspect="wide2_41"
    />
  </div>
</template>
<script>
import VuePicture from "./VuePicture";
import VueSlideshow from "./VueSlideshow";

export default {
  name: "MainMedia",
  components: {
    VuePicture,
    VueSlideshow
  },
  props: {
    media: {
      type: Object
    },
    sizes: {
      type: Array
    },
    full: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 5000
    }
  }
};
</script>